import Plyr from 'plyr';

import 'plyr/dist/plyr.css'
import '../styles/video.scss';

const player = new Plyr('#player');

const Video = ({videoSrc}) => {
 

    return (
      <div className='video_container'>
        <div className="plyr__video-embed" id="player">
          <iframe
            src={videoSrc}
            allowFullScreen={true}
            allowtransparency="true"
            allow="autoplay"
            className="iframe"
          ></iframe>
        </div>
      </div>
    );
  };

  export default Video

  
          